import React from 'react';
import LoadingWrapper, { LoadingContainer } from './styles';

interface LoadingProps {
	size?: number;
	center?: boolean;
	isNormal?: boolean;
	className?: string;
}

const Loading: React.FC<LoadingProps> = ({
	size,
	center,
	isNormal,
	className,
}) => {
	if (center) {
		return (
			<LoadingContainer className={className}>
				<LoadingWrapper $isNormal={isNormal} $size={size} />
			</LoadingContainer>
		);
	}
	return (
		<LoadingWrapper
			className={className}
			$isNormal={isNormal}
			$size={size}
		/>
	);
};

export default Loading;
